import { ThemeConfig } from 'antd';
import { theme } from 'antd';

const { darkAlgorithm } = theme;

// Design tokens for the application
export const tokens = {
  // Brand colors
  colorPrimary: '#2f56df',
  
  // Typography
  fontSize: 14,
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  
  // Spacing scale (px)
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    base: 16,
    lg: 24,
    xl: 32,
  },
  
  // Border radius
  borderRadius: 12,
  borderRadiusLG: 16,
  borderRadiusSM: 8,
  
  // Control heights
  controlHeight: 40,
  controlHeightLG: 48,
  controlHeightSM: 32,
  
  // Layout
  maxContentWidth: 1200,
  headerHeight: 64,
  siderWidth: 240,
  siderCollapsedWidth: 80,
};

// Ant Design theme configuration
export const appTheme: ThemeConfig = {
  algorithm: darkAlgorithm,
  token: {
    colorPrimary: tokens.colorPrimary,
    fontSize: tokens.fontSize,
    fontFamily: tokens.fontFamily,
    borderRadius: tokens.borderRadius,
    borderRadiusLG: tokens.borderRadiusLG,
    borderRadiusSM: tokens.borderRadiusSM,
    controlHeight: tokens.controlHeight,
    controlHeightLG: tokens.controlHeightLG,
    controlHeightSM: tokens.controlHeightSM,
    
    // Spacing
    padding: tokens.spacing.base,
    paddingLG: tokens.spacing.lg,
    paddingXL: tokens.spacing.xl,
    paddingSM: tokens.spacing.sm,
    paddingXS: tokens.spacing.xs,
    margin: tokens.spacing.base,
    marginLG: tokens.spacing.lg,
    marginXL: tokens.spacing.xl,
    marginSM: tokens.spacing.sm,
    marginXS: tokens.spacing.xs,
    
    // Enhanced contrast for dark mode
    colorBgElevated: '#171421',
    colorBgContainer: 'rgba(255, 255, 255, 0.04)',
  },
  components: {
    Layout: {
      headerBg: '#171421',
      headerHeight: tokens.headerHeight,
      siderBg: '#171421',
      bodyBg: '#100d18',
    },
    Card: {
      borderRadiusLG: tokens.borderRadiusLG,
    },
    Button: {
      borderRadius: tokens.borderRadius,
      controlHeight: tokens.controlHeight,
    },
    Input: {
      borderRadius: tokens.borderRadius,
      controlHeight: tokens.controlHeight,
    },
    Select: {
      borderRadius: tokens.borderRadius,
      controlHeight: tokens.controlHeight,
    },
    Dropdown: {
      colorBgElevated: '#171421',
    },
    Drawer: {
      colorBgElevated: '#171421',
    },
    Table: {
      colorBgContainer: '#181522',
      headerBg: '#171421',
      rowHoverBg: '#201b31',
    },
  },
};

export default appTheme;
